import { IconButton } from '@assembly-js/design-system';

import { isElectron } from 'src/hooks/useElectron';
import { useShell } from 'src/legacy/components/Layout/AppShell/ShellContext';

export const DesktopSidebarToggle = () => {
  const {
    isDesktopSidebarCollapsed,
    toggleDesktopSidebar,
    isResizableSidebarActive,
  } = useShell();

  // Only show when the sidebar is closed on desktop so users can reopen it.
  // In the Electron app, the sidebar toggle lives in the chrome bar.
  if (!isResizableSidebarActive || isElectron() || !isDesktopSidebarCollapsed) {
    return null;
  }

  return (
    <IconButton
      size="sm"
      variant="secondary"
      label="Toggle Sidebar"
      icon="Sidebar"
      onClick={toggleDesktopSidebar}
      className="shrink-0"
    />
  );
};
